import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './QuietIconButton.css';

export type QuietIconButtonTone = 'neutral' | 'accent' | 'danger';

export interface QuietIconButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  icon: ReactNode;
  children?: ReactNode;
  tone?: QuietIconButtonTone;
  loading?: boolean;
}

export default function QuietIconButton({
  icon,
  children,
  tone = 'neutral',
  loading = false,
  className = '',
  type = 'button',
  disabled,
  ...props
}: QuietIconButtonProps) {
  const labeled = children != null && children !== false;
  const rootClass = [
    'quiet-icon-button',
    `quiet-icon-button--${tone}`,
    labeled ? 'quiet-icon-button--labeled' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={rootClass}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...props}
    >
      <span className="quiet-icon-button__icon" aria-hidden>
        {loading ? <span className="quiet-icon-button__spinner" /> : icon}
      </span>
      {labeled ? <span className="quiet-icon-button__label">{children}</span> : null}
    </button>
  );
}
